<template>
  <div class="lucky-wheel-container">
    <!-- 兌獎相關UI -->
    <header class="text-tertiary fs-5.5 flexCenter">
      <b>小美幸運星獎項兌換</b>
    </header>

    <!-- <label>
      謝謝您參與小美幸運星活動，以下為您本次提交的資料<br>
      請保留發票截圖或正本，以利獲獎時的資訊核對<br>
      如有任何問題，請來信至 <a href="mailto:tencel.event@gmail.com">tencel.event@gmail.com</a> 詢問
    </label> -->

    <form class="bg-white w-100 p-3 d-flex flex-column gap-3 rounded">
      <b class="text-danger small">* 請填寫正確個人資訊，並詳閱活動說明</b>
      <small class="text-muted">
        <b>注意事項：</b><br>
        1. 一天僅換一個獎項<br>
        2. 數量限定獎品只能兌換一次，無法重複兌換<br>
        3. 運送地址限國內，運費自付<br>
        4. 獎品將於活動結束後統一由主辦單位寄出<br>
        5. 確認中獎/兌換獎品名單將統一公佈在活動主頁
      </small>
      <small class="text-muted text-center">
        LINE身份已認證：
        <img :src="pictureUrl" class="rounded-pill me-2" width="40" height="40">
        <b class="text-black">{{name}}</b>
      </small>

      <div class="row g-0 align-items-center iconInput">
        <div class="col-auto me-3">
          <label for="Name" class="col-form-label">
            <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#customer"/></svg>
          </label>
        </div>
        <div class="col form-floating">
          <input 
            type="text" 
            class="form-control" 
            id="Name" 
            v-model="shippingAddress.recipient_name"
            placeholder="真實姓名">
          <label for="Name">真實姓名 <b class="text-danger"> *</b></label>
        </div>
      </div>

      <div class="row g-0 align-items-center iconInput">
        <div class="col-auto me-3">
          <label for="phone" class="col-form-label">
            <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#phone"/></svg>
          </label>
        </div>
        <div class="col form-floating">
          <input 
            type="tel" 
            class="form-control" 
            id="phone" 
            v-model="shippingAddress.phone"
            placeholder="行動電話">
          <label for="phone">行動電話 <b class="text-danger"> *</b></label>
        </div>
      </div>

      <div class="row g-0 align-items-center iconInput">
        <div class="col-auto me-3">
          <label for="Email" class="col-form-label">
            <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#mail"/></svg>
          </label>
        </div>
        <div class="col form-floating">
          <input 
            type="email" 
            class="form-control" 
            id="Email" 
            v-model="shippingAddress.email"
            placeholder="Email">
          <label for="Email">Email <b class="text-danger"> *</b></label>
        </div>
      </div>

      <div class="row g-0 align-items-center iconInput">
        <div class="col-auto me-3">
          <label for="Addr" class="col-form-label">
            <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#address"/></svg>
          </label>
        </div>
        <div class="col form-floating">
          <input 
            class="form-control" 
            id="Addr"
            type="text" 
            v-model="fullAddress" 
            @input="parseAddress"
            placeholder="請輸入完整地址（例：台北市中正區測試路123號）"
          >
          <label for="Addr">收件地址 <b class="text-danger"> *</b></label>
        </div>
      </div>

      <small class="text-primary text-center mt-3"><b>請選擇您的兌換獎項</b></small>
      <div class="card">
        <ul class="list-group list-group-flush">
          <!-- 已兌換獎項 -->
          <a href="#" class="list-group-item d-flex align-items-center selected"
            v-for="item in redeemedItemsWithDetails" :key="item.item_id">
            <label class="flex-1 small form-check-label stretched-link" :for="'prize-' + item.item_id">
              <div class="d-flex w-100 text-muted justify-content-between align-items-center">
                <div class="flex-1">
                  <b>{{item.name}}</b>
                  <div class="text-muted">
                    <span>市價: <b>{{item.price}}元</b></span><br>
                  </div>
                </div>
              </div>
            </label>
          </a>
          <li v-if="redeemedItemsWithDetails.length" class="list-group-item list-group-item-success text-center success-mix-black-40 small"
          >已兌換</li>

          <!-- 未兌換獎項 -->
          <a href="#" class="list-group-item d-flex align-items-center"
            v-for="item in redeemableItems" :key="item.item_id"
            :class="{'selected': item.item_id === selectedPrize && !isSpecialPrizeSelected}">
            <input class="form-check-input mt-0 me-2"
              type="radio"
              name="prize"
              :id="'prize-' + item.item_id"
              :value="item.item_id"
              v-model="selectedPrize"
              :disabled="item.remaining <= 0 || (userAvailablePoints - item.points_required < 0)">
            <label class="flex-1 small form-check-label stretched-link" :for="'prize-' + item.item_id">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <div class="flex-1">
                  <b>{{item.name}}</b>
                  <div class="text-muted">
                    <span>市價: <b>{{item.price}}元</b></span><br>
                    <span>剩餘數量: <span v-if="item.is_limited == false">無上限</span><b v-else>{{item.remaining}}</b></span>
                  </div>
                </div>
                <span class="text-nowrap ms-2">需 <b class="text-primary">{{item.points_required}}</b> 點</span>
              </div>
            </label>
          </a>

          <!-- 轉盤特獎 -->
          <a v-if="specialPrizeStatus?.has_special_prize && !specialPrizeStatus?.is_redeemed" 
            href="#" 
            class="list-group-item d-flex align-items-center"
            :class="{'selected': selectedPrize === specialPrizeStatus.item_id && isSpecialPrizeSelected}">
            <input class="form-check-input mt-0 me-2"
              type="radio"
              name="prize"
              id="prize-special"
              :value="specialPrizeStatus.item_id"
              v-model="selectedPrize"
              @change="handlePrizeSelect">
            <label class="flex-1 small form-check-label stretched-link" for="prize-special">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <div class="flex-1">
                  <b>{{specialPrizeStatus.name}}</b>
                  <div class="text-muted">
                    <span>市價: <b>{{specialPrizeStatus.price}}元</b></span><br>
                  </div>
                </div>
              </div>
            </label>
          </a>
        </ul>
        <div class="card-footer d-flex justify-content-evenly small">
          <span>您的點數: <b class="text-danger fs-6">{{userAvailablePoints}}</b></span>
          <span>扣除後剩餘: <b class="text-danger fs-6">{{isSpecialPrizeSelected ? userAvailablePoints : remainingPoints}}</b></span>
        </div>
      </div>

      <div class="form-check">
        <input 
          class="form-check-input" 
          type="checkbox" 
          id="agreeTerms"
          v-model="termsAgreed"
        >
        <label class="form-check-label text-primary small" for="agreeTerms">
          <b>我已詳閱活動辦法與注意事項，並同意個人資料之蒐集告知</b><b class="text-danger"> *</b>
        </label>
      </div>
      
      <div>
        <button class="border-0 rounded-1 bg-primary text-white w-100 small p-2 mb-2" type="button" data-bs-toggle="collapse" data-bs-target="#terms" aria-expanded="false" aria-controls="terms">
          <b>活動條款與隱私聲明</b>
        </button>
        <div class="collapse" id="terms">
          <div class="card card-body small">
            <div class="smaller">
              <h6>活動條款</h6>
              <p>感謝您參與小美幸運星輪盤活動（以下稱「本活動」）。為確保每位參與者的權益，請詳閱以下條款：</p>

              <p class="mb-1">活動期間：2025/1/1 - 2025/2/28</p>

              <h6 class="mb-1"><b>1. 遊戲規則</b></h6>
              <ul class="mb-2">
                <li>每日基本可玩 2 次</li>
                <li>每日清晨 5:00 重置遊戲次數</li>
                <li>兩次遊戲需間隔 8 小時</li>
              </ul>

              <h6 class="mb-1"><b>2. 遊戲時間說明</b></h6>
              <ul class="mb-2">
                <li>每日清晨 5:00 後即可開始遊玩</li>
                <li>第一次遊玩後，需等待 8 小時才能進行第二次</li>
              </ul>

              <h6 class="mb-1"><b>3. 額外獎勵機會</b></h6>
              <ul class="mb-2">
                <li>成功邀請 10 位不重複好友參與遊戲</li>
                <li>達成後即可獲得 Bonus 遊戲機會</li>
                <li>Bonus 次數不受間隔時間限制</li>
                <li>每日可使用 1 次 Bonus 機會</li>
              </ul>

              <h6 class="mb-1"><b>4. 獎品兌換注意事項</b></h6>
              <ul class="mb-3">
                <li>一天僅換一個獎項</li>
                <li>數量限定獎品只能兌換一次，無法重複兌換</li>
                <li>運送地址限國內，運費自付</li>
                <li>獎品將於活動結束後統一由主辦單位寄出</li>
                <li>確認中獎/兌換獎品名單將統一公佈在活動主頁</li>
              </ul>

              <h6>隱私聲明</h6>
              <p>本隱私聲明旨在說明 博祥國際股份有限公司（以下稱「本公司」）如何收集、使用、保護及處理您在參與小美幸運星輪盤活動（以下稱「本活動」）時所提供的個人資料。</p>

              <h6 class="mb-1">1. 資料的收集：</h6>
              <ul class="mb-2">
                <li>本公司可能會收集您的姓名、聯絡方式、LINE 用戶 ID 等必要資訊，以進行活動資格驗證及獎品發送。</li>
              </ul>

              <h6 class="mb-1">2. 資料的使用：</h6>
              <ul class="mb-2">
                <li>用於確認活動參與資格。</li>
                <li>用於獎品通知及發送。</li>
                <li>作為日後市場分析或行銷活動之參考（僅在得到您的同意後）。</li>
              </ul>

              <h6 class="mb-1">3. 資料的保護：</h6>
              <ul class="mb-2">
                <li>本公司將採取合理的技術及管理措施，確保您的個人資料不遭未經授權的存取、披露、修改或損毀。</li>
              </ul>

              <h6 class="mb-1">4. 資料的分享：</h6>
              <ul class="mb-2">
                <li>為達成獎品發送及兌換目的，您的資料可能會提供給贊助廠商，但僅限於此用途。</li>
                <li>除法律要求或經您同意外，本公司不會將您的個人資料提供予第三方。</li>
              </ul>

              <h6 class="mb-1">5. 資料的保存：</h6>
              <ul class="mb-2">
                <li>您的個人資料將保存至活動結束後六個月，逾期將予以刪除或匿名化處理。</li>
              </ul>

              <h6 class="mb-1">6. 您的權利：</h6>
              <ul class="mb-2">
                <li>您有權查詢、更正或請求刪除您的個人資料。</li>
                <li>若您希望行使上述權利，請聯繫本公司客服人員。</li>
              </ul>

              <h6 class="mb-1">7. 隱私聲明的修訂：</h6>
              <ul class="mb-2">
                <li>本公司保留隨時修訂本隱私聲明的權利，修訂後的內容將公布於相關平台上。</li>
              </ul>

              <h6 class="mb-1">8. 聯絡方式：</h6>
              <ul class="mb-2">
                <li>如對本隱私聲明有任何疑問，請聯繫本公司客服信箱：customer@camangi.com</li>
              </ul>

              <p>參與本活動即表示您已閱讀、了解並同意遵守上述「活動條款」及「隱私聲明」之所有內容。</p>
            </div>
          </div>
        </div>
      </div>

      <button 
        class="btn btn-tertiary warning-mix-black-50 h-48 d-block mx-auto w-100 mb-3"
        @click.prevent="handleRedeem"
        :disabled="!isFormValid || isSubmitting">
        <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <b>確認兌換</b>
      </button>
          
    </form>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { showModal, cleanupModals } from '@/utils/modal'
import { extractPostalCode } from '@/utils/addressUtils'
import axios from 'axios'
import DiscordNotification from '@/utils/discordNotification'

const eventId = process.env.VUE_APP_LUCKY_WHEEL_EVENT_ID;

export default {
  name: 'RewardRedeem',
  props: {
    redeemableItems: {
      type: Array,
      default: () => []
    },
    myRedemptions: {
      type: Array,
      default: () => []
    },
    userPoints: {
      type: Number,
      default: 0
    },
    userAvailablePoints: {
      type: Number,
      default: 0
    },
    gameToken: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fullAddress: '',
      shippingAddress: {
        recipient_name: '',
        phone: '',
        email: '',
        postal_code: '',
        city: '',
        district: '',
        address: ''
      },
      selectedPrize: null,
      specialPrizeStatus: null,
      isSubmitting: false,
      termsAgreed: false
    }
  },
  created() {
    this.shippingAddress.email = this.email
  },
  mounted() {
    this.fetchSpecialPrizeStatus()
  },
  unmounted() {
    cleanupModals()
  },
  computed: {
    ...mapGetters(['userId', 'token', 'name', 'email', 'pictureUrl']),
    formattedJson() {
      return JSON.stringify({ shipping_address: this.shippingAddress }, null, 2)
    },
    selectedPrizeDetails() {
      if (this.isSpecialPrizeSelected) {
        return {
          name: this.specialPrizeStatus.name,
          price: this.specialPrizeStatus.price,
          points_required: this.specialPrizeStatus.points_required
        }
      }
      return this.redeemableItems.find(item => item.item_id === this.selectedPrize)
    },
    remainingPoints() {
      const selectedPrizeDetails = this.redeemableItems.find(item => item.item_id === this.selectedPrize)
      const pointsRequired = selectedPrizeDetails ? selectedPrizeDetails.points_required : 0
      return this.userAvailablePoints - pointsRequired
    },
    isFormValid() {
      return this.termsAgreed &&
             this.selectedPrize && 
             this.shippingAddress.recipient_name &&
             this.shippingAddress.phone &&
             this.shippingAddress.city &&
             this.shippingAddress.district &&
             this.shippingAddress.address
    },
    redeemedItemsWithDetails() {
      if (!this.myRedemptions || !this.redeemableItems) {
        return []
      }
      
      return this.myRedemptions.map(redemption => {
        const itemDetails = this.redeemableItems.find(item => 
          item.item_id === redemption.item_id
        ) || {}
        
        return {
          ...redemption,
          name: itemDetails.name,
          price: itemDetails.price,
          description: itemDetails.description
        }
      })
    },
    isSpecialPrizeSelected() {
      return this.selectedPrize === this.specialPrizeStatus?.item_id
    }
  },
  methods: {
    closeReward() {
      this.$emit('close')
    },
    async parseAddress() {
      let address = this.fullAddress.trim()

      // Initialize shippingAddress object if it's not already an object
      if (typeof this.shippingAddress !== 'object' || this.shippingAddress === null) {
        this.shippingAddress = {
          recipient_name: '',
          phone: '',
          email: '',
          postal_code: '',
          city: '',
          district: '',
          address: ''
        };
      }

      // 郵遞區號比對 (3-5碼數字)
      const postalRegex = /^(\d{3,5})/
      const postalMatch = address.match(postalRegex)
      
      if (postalMatch) {
        this.shippingAddress.postal_code = postalMatch[0]
        address = address.replace(postalRegex, '').trim()
      }

      // 縣市比對
      const cityRegex = /(台北市|新北市|台中市|台南市|高雄市|基隆市|新竹市|嘉義市|桃園市|新竹縣|苗栗縣|彰化縣|南投縣|雲林縣|嘉義縣|屏東縣|宜蘭縣|花蓮縣|台東縣|澎湖縣|金門縣|連江縣)/
      const cityMatch = address.match(cityRegex)
      
      if (cityMatch) {
        this.shippingAddress.city = cityMatch[0]
        address = address.replace(cityRegex, '').trim()
      }

      // 區域比對
      const districtRegex = /(.+?[區市鄉鎮])/
      const districtMatch = address.match(districtRegex)
      
      if (districtMatch) {
        this.shippingAddress.district = districtMatch[0]
        address = address.replace(districtRegex, '').trim()
      }

      // 剩餘文字為詳細地址
      this.shippingAddress.address = address

      // 發送解析結果
      this.$emit('address-parsed', this.shippingAddress)
    },
    // 兌獎相關方法
    async handleRedeem() {
      if (!this.isFormValid) {
        showModal('請填寫完整資料')
        return
      }

      // Skip points check for special prize
      if (!this.specialPrizeStatus?.has_special_prize && this.remainingPoints < 0) {
        showModal('您的點數不足')
        return
      }
      
      this.isSubmitting = true

      // Check and fill postal code if missing
      if (!this.shippingAddress.postal_code) {
        const postalCode = await extractPostalCode(this.fullAddress, process.env.VUE_APP_API_URL) || '00000'
        this.shippingAddress.postal_code = postalCode
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/redemption/redeem/${eventId}`,
          {
            item_id: this.selectedPrize,
            shipping_address: this.shippingAddress
          },
          {
            headers: {
              'Authorization': `Bearer ${this.gameToken}`,
              "ngrok-skip-browser-warning": "69420"
            }
          }
        )

        const data = response.data
        
        // 發送 Discord 通知
        await DiscordNotification.send({
          prize: {
            name: this.selectedPrizeDetails.name,
            price: this.selectedPrizeDetails.price,
            points_required: this.selectedPrizeDetails.points_required
          },
          shipping: {
            recipient_name: this.shippingAddress.recipient_name,
            phone: this.shippingAddress.phone,
            email: this.shippingAddress.email,
            postal_code: this.shippingAddress.postal_code,
            city: this.shippingAddress.city,
            district: this.shippingAddress.district,
            address: this.shippingAddress.address
          },
          response: {
            status: data.status || 'success',
            message: data.message,
            redemption_id: data.redemption_id
          }
        });

        showModal('兌換成功！我們將盡快為您處理', { autoCloseSeconds: 3 })

        // Refresh current component after modal auto-closes
        setTimeout(() => {
          this.$router.go(0)
        }, 3000)
        
      } catch (error) {
        if (error.response && error.response.status === 400 && error.response.data.detail === "Daily redemption limit reached") {
          showModal('今日已經兌換過了喔！')
        } else {
          await DiscordNotification.send({
            prize: {
              name: this.selectedPrizeDetails.name,
              price: this.selectedPrizeDetails.price,
              points_required: this.selectedPrizeDetails.points_required
            },
            shipping: {
              recipient_name: this.shippingAddress.recipient_name,
              phone: this.shippingAddress.phone,
              email: this.shippingAddress.email,
              postal_code: this.shippingAddress.postal_code,
              city: this.shippingAddress.city,
              district: this.shippingAddress.district,
              address: this.shippingAddress.address
            },
            response: {
              status: 'error',
              message: error.response?.data?.detail || '兌換失敗，請稍後再試'
            }
          });
          showModal(error.response?.data?.detail || '兌換失敗，請稍後再試')
        }
      } finally {
        this.isSubmitting = false
      }
    },
    async fetchSpecialPrizeStatus() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/redemption/special/${eventId}`,
          {
            headers: {
              'Authorization': `Bearer ${this.gameToken}`,
              "ngrok-skip-browser-warning": "69420"
            }
          }
        )
        this.specialPrizeStatus = response.data
      } catch (error) {
        console.error('Failed to fetch special prize status:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-group-item.selected {
    background-color: #e3f5f8;
  }
</style>